module.exports = __webpack_public_path__ + "img/borderObliqueCornerWhite.5dac005f.svg";